<template>
  <div id="content">
    <sweet-modal ref="modal" title="Preview">
      <div>
        <iframe
          :src="`https://lucien-test-builder.netlify.app/form/${formId}`"
        ></iframe>
      </div>
    </sweet-modal>
    <div class="contenair bg-gradient">
      <h1 class="title">
        &nbsp;<i class="fa fa-file-text-o" aria-hidden="true"></i>&nbsp;
        {{ title }}
      </h1>
     <br />
      <MenuOperation
        :id="operationId"
        :type="typejeu"
      />
      <div class="form-container-step">
        <form class="dataform">
          <h1>&Eacute;léments du formulaire</h1>
          <div class="add-op">
            <button class="btn-blue-inline btn-resize" v-on:click="addNewStep">
              <i class="fa fa-plus"></i> Ajouter une étape
            </button>
          </div>
          <br />
          <BulmaAccordion
            :dropdown="false"
            :icon="'custom'"
            :caretAnimation="{
              duration: '.3s',
              timerFunc: 'ease-in-out',
            }"
            :slide="{
              duration: '.5s',
              timerFunc: 'ease',
            }"
          >
            <div>
              <BulmaAccordionItem>
                <i slot="icon-closed" class="material-icons">
                  <svg
                    data-v-bc7d9a68=""
                    version="1.1"
                    viewBox="0 0 129 129"
                    enable-background="new 0 0 129 129"
                    class="header-icon"
                    style="transition: all 0.3s ease-in-out 0s;"
                  >
                    <g data-v-bc7d9a68="">
                      <path
                        data-v-bc7d9a68=""
                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                      ></path>
                    </g>
                  </svg>
                </i>
                <i slot="icon-open" class="material-icons">
                  <svg
                    data-v-bc7d9a68=""
                    version="1.1"
                    viewBox="0 0 129 129"
                    enable-background="new 0 0 129 129"
                    class="header-icon caret-down"
                    style="transition: all 0.3s ease-in-out 0s;"
                  >
                    <g data-v-bc7d9a68="">
                      <path
                        data-v-bc7d9a68=""
                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                      ></path>
                    </g>
                  </svg>
                </i>

                <h4 slot="title">Configuration</h4>
                <div class="step-content" slot="content">
                  <div class="contenair">
                    <div class="form-elements">
                      <div class="step-contenair">
                        <div class="elem">
                          <label
                            >BOUTON :
                            <span class="defaut"
                              >PR&Eacute;C&Eacute;DENT</span
                            ></label
                          >
                          <input
                            type="text"
                            name="bouton_text[precedent]"
                            v-model="bouton_text.precedent"
                            placeholder="Par défaut : Précedent"
                          />
                        </div>

                        <div class="elem">
                          <label
                            >BOUTON : <span class="defaut">SUIVANT</span></label
                          >
                          <input
                            type="text"
                            name="bouton_text[suivant]"
                            v-model="bouton_text.suivant"
                            placeholder="Par défaut : Suivant"
                          />
                        </div>

                        <div class="elem">
                          <label
                            >BOUTON : <span class="defaut">VALIDER</span></label
                          >
                          <input
                            type="text"
                            name="bouton_text[valider]"
                            v-model="bouton_text.valider"
                            placeholder="Par défaut : Valider"
                          />
                        </div>
                        <div class="elem">
                          <label
                            >BOUTON :
                            <span class="defaut">VALIDER</span> display If
                            :</label
                          >
                          <input
                            type="text"
                            name="bouton_text[displayIf]"
                            v-model="bouton_text.displayIf"
                            placeholder="this.form.blabla == true"
                          />
                        </div>
                        <div class="elem">
                          <label>BOUTON VALIDER SPINNER</label>
                          <input
                            type="checkbox"
                            name="bouton_text[hasSpinner]"
                            v-model="bouton_text.hasSpinner"
                          />
                        </div>
                        <div class="elem">
                          <label>NOMBRE DE CODE A VERIFIER</label>
                          <input
                            type="number"
                            name="numberOfCodes"
                            v-model.number="numberOfCodes"
                          />
                        </div>
                        <div class="elem">
                          <label>Langue</label>
                          <multiselect
                            v-model="lang"
                            id="newForm.lang"
                            :options="[
                              'de',
                              'fr',
                              'be-fr',
                              'be-nl',
                              'nl',
                              'pl',
                              'es-es',
                              'es-cat',
                              'it',
                              'en',
                              'lu-fr',
                              'lu-nl',
                              'ro',
                              'sl',
                              'bg',
                              'gr',
                            ]"
                            :multiple="false"
                            v-validate="'required'"
                            :searchable="false"
                            name="type"
                            placeholder="Lang"
                            select-label="Cliquez pour ajouter"
                            deselect-label="Cliquez pour supprimer"
                          ></multiselect>
                        </div>
                        <div v-if="this.type === 'UPDATE'" class="elem">
                          <label>STATUS TO_CHECK_AGAIN</label>
                          <input
                            type="checkbox"
                            name="form[changeStatusTocheckAgain]"
                            v-model="changeStatusTocheckAgain"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </BulmaAccordionItem>
            </div>

            <div
              v-for="(step, indexStep) in form"
              :v-bind="form"
              :key="indexStep"
              class="item"
            >
              <BulmaAccordionItem>
                <i slot="icon-closed" class="material-icons">
                  <svg
                    data-v-bc7d9a68=""
                    version="1.1"
                    viewBox="0 0 129 129"
                    enable-background="new 0 0 129 129"
                    class="header-icon"
                    style="transition: all 0.3s ease-in-out 0s;"
                  >
                    <g data-v-bc7d9a68="">
                      <path
                        data-v-bc7d9a68=""
                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                      ></path>
                    </g>
                  </svg>
                </i>
                <i slot="icon-open" class="material-icons">
                  <svg
                    data-v-bc7d9a68=""
                    version="1.1"
                    viewBox="0 0 129 129"
                    enable-background="new 0 0 129 129"
                    class="header-icon caret-down"
                    style="transition: all 0.3s ease-in-out 0s;"
                  >
                    <g data-v-bc7d9a68="">
                      <path
                        data-v-bc7d9a68=""
                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                      ></path>
                    </g>
                  </svg>
                </i>

                <h4 slot="title" v-if="step.name">{{ step.name }}</h4>
                <h4 slot="title" v-else>&Eacute;tape {{ indexStep + 1 }}</h4>

                <div class="step-content" slot="content">
                  <div class="contenair">
                    <label>Nom de l'étape: </label>
                    <input
                      type="text"
                      v-model="step.name"
                      name="form[][name]"
                      placeholder="Name"
                    />
                    <hr />
                    <div class="formelements">
                      <!-- Menu Deroulant (liste des champs ) -->
                      <dropdown :close-on-click="true">
                        <template slot="btn"
                          ><i class="fa fa-plus"></i> &nbsp;Ajouter un élément
                          au formulaire&nbsp;</template
                        >
                        <template slot="body">
                          <div
                            v-for="(element, indexElem) in elementsKey"
                            :key="indexElem"
                            @click="addField(element, indexStep)"
                            class="fields"
                          >
                            {{ element }}
                          </div>
                        </template>
                      </dropdown>
                    </div>
                    <br />

                    <draggable
                      :list="form[indexStep].fields"
                      handle=".grabbable"
                      v-bind="dragOptions"
                      @start="isDragging = true"
                      @end="isDragging = false"
                    >
                      <transition-group type="transition" name="flip-list">
                        <div
                          v-for="(field, i) in form[indexStep].fields"
                          :key="i + 1"
                        >
                          <BulmaAccordion
                            :dropdown="false"
                            :icon="'custom'"
                            :caretAnimation="{
                              duration: '.3s',
                              timerFunc: 'ease-in-out',
                            }"
                            :slide="{
                              duration: '.5s',
                              timerFunc: 'ease',
                            }"
                          >
                            <BulmaAccordionItem>
                              <i slot="icon-closed" class="material-icons">
                                <svg
                                  data-v-bc7d9a68=""
                                  version="1.1"
                                  viewBox="0 0 129 129"
                                  enable-background="new 0 0 129 129"
                                  class="header-icon"
                                  style="transition: all 0.3s ease-in-out 0s;"
                                >
                                  <g data-v-bc7d9a68="">
                                    <path
                                      data-v-bc7d9a68=""
                                      d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                                    ></path>
                                  </g>
                                </svg>
                              </i>
                              <i slot="icon-open" class="material-icons">
                                <svg
                                  data-v-bc7d9a68=""
                                  version="1.1"
                                  viewBox="0 0 129 129"
                                  enable-background="new 0 0 129 129"
                                  class="header-icon caret-down"
                                  style="transition: all 0.3s ease-in-out 0s;"
                                >
                                  <g data-v-bc7d9a68="">
                                    <path
                                      data-v-bc7d9a68=""
                                      d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                                    ></path>
                                  </g>
                                </svg>
                              </i>
                              <h4
                                :class="{
                                  incomplete:
                                    field.save_to == undefined &&
                                    field.name !== 'BlocHTML' &&
                                    field.name !== 'BlocHTMLsimple',
                                  BlocHTML:
                                    field.name == 'BlocHTML' ||
                                    field.name == 'BlocHTMLsimple',
                                }"
                                slot="title"
                              >
                                <img
                                  class="grabbable"
                                  src="../assets/images/move.png"
                                />
                                Élément {{ i + 1 }} :
                                {{
                                  field.validationLabel ||
                                    field.label ||
                                    (field.name == "api_field" ? "API" : "-")
                                }}
                                # {{ field.name }} ({{
                                  field.component
                                }})&nbsp;<span v-if="field.name !== 'BlocHTML'">
                                  --> {{ field.save_to }}</span
                                >
                              </h4>
                              <div class="step-content" slot="content">
                                <div
                                  class="buttons"
                                  style="display: flex;justify-content: flex-end;"
                                >
                                  <button
                                    type="button"
                                    class="smallbutton"
                                    v-if="!JSONEditorActivated[i]"
                                    @click="toggleJSONEditor(i)"
                                  >
                                    JSON
                                  </button>
                                  <button
                                    type="button"
                                    class="smallbutton"
                                    v-else
                                    @click="toggleJSONEditor(i)"
                                  >
                                    FORM
                                  </button>
                                </div>
                                <div
                                  class="container"
                                  v-if="!JSONEditorActivated[i]"
                                >
                                  <component
                                    :is="Element"
                                    :index="i"
                                    :operationId="operationId"
                                    :saveToAvailable="saveToAvailable"
                                    :saveToAvailableInitially="
                                      saveToAvailableInitially
                                    "
                                    :field="form[indexStep].fields[i]"
                                  ></component>
                                  <br />
                                  <a
                                    class="remove-field"
                                    v-on:click="removeField(indexStep, i)"
                                    ><i class="fa fa-trash-o"></i> Supprimer ce
                                    champ</a
                                  >
                                </div>
                                <div class="container" v-else>
                                  <JSONEditor
                                    v-model="form[indexStep].fields[i]"
                                  ></JSONEditor>
                                </div>
                              </div>
                            </BulmaAccordionItem>
                          </BulmaAccordion>
                        </div>
                      </transition-group>
                    </draggable>
                    <br />
                    <a class="deletestep" v-on:click="removeStep(indexStep)"
                      ><i class="fa fa-trash-o"></i> Supprimer cette étape</a
                    >
                  </div>
                </div>
              </BulmaAccordionItem>
            </div>
          </BulmaAccordion>
          <br /><br />
          <div class="form-end">
            <button
              v-if="formType === 'CREATE'"
              class="btn-blue-inline btn-resize"
              v-on:click="openModal()"
            >
              <i class="fa fa-eye" aria-hidden="true"></i> Prévisualiser
            </button>
            &nbsp;
            <button class="btn-blue btn-resize" v-on:click.prevent="sumbitForm">
              <i class="fa fa-save"></i> Sauvegarder
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
//const Components = require("oxo-form-components");
import MenuOperation from "@/components/MenuOperation";
import Element from "../components/formElements/ElementV2";
import JSONEditor from "../components/JSONEditor";
import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";
import Dropdown from "bp-vuejs-dropdown";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import draggable from "vuedraggable";
import elements from "../components/formElements/elems";
//const components = Components.load("fr-fr");
import Multiselect from "vue-multiselect";


export default {
  components: {
    MenuOperation,
    Element,
    Multiselect,
    BulmaAccordion,
    BulmaAccordionItem,
    Dropdown,
    SweetModal,
    SweetModalTab,
    JSONEditor,
    draggable,
  },
  data() {
    return {
      title: undefined,
      type: undefined,
      operationId: undefined,
      form: [],
      lang: undefined,
      bouton_text: {},
      numberOfCodes: 0,
      changeStatusTocheckAgain: false,
      Filtered: [],
      JSONEditorActivated: {},
      Element: "Element",
      rawElements: [],
      elements,
      saveToAvailable: [],
      saveToAvailableInitially: [],
      formId: this.$route.params._id,
      formType: undefined,
      typejeu: undefined,
    };
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler() {
        this.computeAvailableSaveto();
      },
    },
  },
  computed: {
    elementsKey() {
      // console.log("this.elements", this.elements);
      return Object.keys(this.elements);
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  async mounted() {
    let response = await this.$axios.get("/api/v2/formulaires/" + this.$route.params._id);
    let formulaire = response.data.formulaire || {};
    this.formType = formulaire.type;
    this.form = formulaire;
    this.lang = this.form.lang;

    let ope = await this.$axios.get("/api/operations/" + formulaire.operationId);
    this.typejeu = ope.data.type;

    this.operationId = formulaire.operationId;
    this.title = ope.data.title;

    if (formulaire.bouton_text) {
      this.bouton_text = formulaire.bouton_text;
    } else {
      this.bouton_text = { hasSpinner: true };
    }

    this.numberOfCodes = formulaire.numberOfCodes;
    this.changeStatusTocheckAgain = formulaire.changeStatusTocheckAgain;
    if (formulaire.form) {
      this.form = formulaire.form;
    } else {
      this.form = [{}];
    }

    this.type = formulaire.type;

    let response2 = await this.$axios.get("/api/v2/formulaires/" + (this.type == "LINE_ITEM" ? "save_to_values_lineitem" : "save_to_values")
    );

    this.saveToAvailableInitially = [];
    for (let [key, value] of Object.entries(response2.data)) {
      value.key = key;
      this.saveToAvailableInitially.push(value);
    }
    // console.log("saveToAvailableInitially", this.saveToAvailableInitially);
    this.saveToAvailable = this.saveToAvailableInitially;
    this.computeAvailableSaveto();
  },
  methods: {
    computeAvailableSaveto() {
      let usedSaveTo = [];
      for (let index = 0; index < this.form.length; index++) {
        const step = this.form[index].fields;
        if (step) {
          for (let j = 0; j < step.length; j++) {
            const field = step[j];
            if (field.save_to) {
              usedSaveTo.push(field.save_to);
            }
          }
        }
      }
      this.saveToAvailable = this.saveToAvailableInitially.filter((sto) => {
        return !usedSaveTo.includes(sto.key);
      });
    },
    toggleJSONEditor(index) {
      Vue.set(
        this.JSONEditorActivated,
        index,
        !this.JSONEditorActivated[index]
      );
    },
    inputTypeName(input_type) {
      return input_type + "__inputTypeName";
    },
    async sumbitForm() {
      event.preventDefault();
      this.cleanArray();


      for (const [key, value] of Object.entries(this.form)) {
        if (value && value.fields) {
          for (const [k, v] of Object.entries(value.fields)) {
            if (
              v.label === "VALID" &&
              v.component === "BlocHTML" &&
              !v.displayIf
            ) {
              this.form[key].fields[k].displayIf =
                "this.form.participationValide === 'VALID'";


            }
            if (
              v.label === "INVALID" &&
              v.component === "BlocHTML" &&
              !v.displayIf
            ) {
              this.form[key].fields[k].displayIf =
                "this.form.participationValide === 'INVALID'";

            }
            if (
              v.label === "PENDING" &&
              v.component === "BlocHTML" &&
              !v.displayIf
            ) {
              this.form[key].fields[k].displayIf =
                "this.form.participationValide === 'PENDING'";

            }
            if (
              v.label === "TO_CHECK_AGAIN" &&
              v.component === "BlocHTML" &&
              !v.displayIf
            ) {
              this.form[key].fields[k].displayIf =
                "this.form.participationValide === 'TO_CHECK_AGAIN'";

            }
            if (
              v.label === "MISSING" &&
              v.component === "BlocHTML" &&
              !v.displayIf
            ) {
              this.form[key].fields[k].displayIf =
                "this.form.participationValide === 'MISSING'";

            }
            if (
              v.label === "REFUND_DONE" &&
              v.component === "BlocHTML" &&
              !v.displayIf
            ) {
              this.form[key].fields[k].displayIf =
                "this.form.participationValide === 'REFUND_DONE'";

            }
            if (
              v.label === "SENT_TO_LOGISTIC" &&
              v.component === "BlocHTML" &&
              !v.displayIf
            ) {
              this.form[key].fields[k].displayIf =
                "this.form.participationValide === 'SENT_TO_LOGISTIC'";

            }
            if (
              v.label === "MOTIF_NC" &&
              v.component === "BlocHTML" &&
              !v.displayIf
            ) {
              this.form[key].fields[k].displayIf =
                "(this.form.participationValide === 'INVALID' || this.form.participationValide === 'MISSING') && this.form.motif_nc";

            }
          }
        }
      }

      this.form.lang = this.lang;
      this.form.form = this.form;

      try {
        let result = await this.$axios.put("/api/v2/formulaires/" + this.$route.params._id,
            {
              ...this.form,
              bouton_text: this.bouton_text,
              numberOfCodes: this.numberOfCodes,
              changeStatusTocheckAgain: this.changeStatusTocheckAgain,
            }
        );
        if (result.data) {
          this.$swal({
            position: "top-end",
            type: "success",
            title: "Modifications sauvegardées",
            showConfirmButton: false,
            timer: 1500,
          });

        }
      } catch (error) {
        console.log(error);
      }
    },
    addNewStep: function() {
      event.preventDefault();
      this.form.push(Vue.util.extend({}, this.step));
    },
    removeStep: function(index) {
      this.$swal({
        title: "&Ecirc;tes vous sur ?",
        text: "Supprimer cette étape !",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, je la supprime !",
      }).then((result) => {
        if (result.value) {
          Vue.delete(this.form, index);
          this.$swal(
            "Supprimée !",
            "Cette étape à bien été supprimée.",
            "success"
          );
        }
      });
    },
    addField(selectedElem, iStep) {
      if (!this.form[iStep].fields) {
        Vue.set(this.form[iStep], "fields", []);
      }
      if (selectedElem === "address" && this.typejeu === "JEU SOA") {
        this.elements[selectedElem].configuration = {
          displayFieldsAfterSelection: false,
          forceForm: true,
        };
        console.log(this.elements[selectedElem]);
      }

      this.form[iStep].fields.push({ ...this.elements[selectedElem] });
    },
    removeField: function(iStep, iField) {
      this.$swal({
        title: "&Ecirc;tes vous sur ?",
        text: "Supprimer ce champ !",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, je le supprime !",
      }).then((result) => {
        if (result.value) {
          Vue.delete(this.form[iStep].fields, iField);
          this.$forceUpdate();
        }
      });
    },
    openModal() {
      event.preventDefault();
      this.$refs.modal.open();
      return;
    },
    cleanArray() {
      this.form.forEach(function(element) {
        if (element === "") {
        }
        console.log(element);
      });
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>
